import { MAX_PER_PAGE } from 'utils/constants'
import { baseApi } from './baseApi'
import { ISubject } from 'types'

export const subjectsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    GET_subjects: builder.query<any, any>({
      query: (params) => ({
        url: '/subjects/',
        params: params,
      }),
      providesTags: ['subjects'],
    }),

    GET_subjectsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/subjects/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['subjects'],
    }),

    GET_subjectById: builder.query<ISubject, string>({
      query: (id) => {
        return {
          url: `/subjects/${id}/`,
        }
      },
      providesTags: ['subjects'],
    }),
  }),
})

export const { 
  useGET_subjectsQuery,
  useGET_subjectsSelectQuery,
  useGET_subjectByIdQuery
} =subjectsAPI
